import React from 'react';
import {bool, func, object} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {platformMappings} from 'utils/DBUtils';
import {basicForm} from 'utils/helpers';
import config from './addStepFormConfig';

const AddStepsForm = basicForm(config);

const AddStepsModal = props => (
    <BasicModal
        header={`Add one or more steps to the ${platformMappings[props.currentPlatform] || 'Master'} platform.`}
        specialType='db-steps-modal primary-modal'
        dimmer={'inverted'}
        modalSize='small'
        actions={[
            {
                label: 'Cancel',
                action: props.handleClose,
                isDisabled: false,
                displayType: 'menu-item'
            },
            {
                label: 'Save',
                action: props.submit,
                isDisabled: false,
                displayType: 'button',
                primaryCheck: true
            }
        ]}
        open={props.modalOpen}
        onClose={props.handleClose}>
        <AddStepsForm onValueChanged={props.onValueChanged}
                      onValidationError={props.onValidationError}
                      errors={props.errors}
                      data={props.formData}/>
    </BasicModal>
);

AddStepsModal.propTypes = {
    formData: object.isRequired,
    onSaveData: func.isRequired,
    formValueChanged: func.isRequired,

    handleClose: func.isRequired,
    modalOpen: bool.isRequired
};

export default AddStepsModal;



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/AddSteps/AddStepsModal.jsx